// Public, bounded labels only. Keep technical event IDs stable for history and ecommerce.
export const ANALYTICS_LABELS_ZH = Object.freeze({
  calculator_cta_clicked: '点击免费排盘入口',
  guide_cta_clicked: '文章引导进入排盘',
  report_sales_cta_clicked: '销售页引导进入排盘',
  report_demo_cta_clicked: '样本页引导进入排盘',
  report_sample_cta_clicked: '示例报告引导进入排盘',
  report_demo_opened: '打开报告样本',
  chart_form_started: '开始填写排盘资料',
  chart_entry_submitted: '首页资料提交并跳转',
  chart_form_error: '排盘输入或计算失败',
  chart_generated: '免费排盘成功',
  bazi_chart_generated: '八字排盘成功（专项）',
  intent_preview_viewed: '查看个性化解读',
  personalized_preview_viewed: '查看紫微解读预览（专项）',
  bazi_preview_viewed: '打开八字报告预览',
  crosscheck_preview_viewed: '打开紫微八字联盘预览',
  palace_selected: '查看紫微宫位',
  bazi_pillar_selected: '查看八字柱位',
  annual_year_selected: '切换规划年份',
  report_goal_selected: '选择报告目标',
  relationship_report_interest: '表达关系报告兴趣',
  birth_time_comparison_opened: '打开相邻时辰对照',
  birth_time_comparison_viewed: '查看相邻时辰对照',
  offer_viewed: '查看付费产品',
  report_offer_viewed: '查看紫微产品（专项）',
  bazi_offer_viewed: '查看八字产品（专项）',
  conversion_cta_clicked: '点击报告行动引导',
  offer_selected: '选择付费产品',
  begin_checkout: '发起支付',
  checkout_modal_opened: '打开支付弹窗',
  checkout_ready: '支付会话已就绪',
  payment_element_ready: '支付表单已就绪',
  checkout_error: '支付流程出错',
  checkout_cancelled: '取消托管支付',
  checkout_closed: '关闭支付弹窗',
  checkout_fallback_selected: '切换到托管支付',
  purchase: '付款已验证',
  snapshot_purchased: '购买紫微快照（专项）',
  upgrade_started: '开始报告升级',
  upgrade_purchased: '报告升级付款已验证（专项）',
  pdf_downloaded: 'PDF 下载已发起',
  bazi_pdf_downloaded: '八字 PDF 下载已发起（专项）',
  pdf_download_error: 'PDF 生成失败',
  email_captured: '提交报告联系邮箱',
  restore_panel_opened: '打开已购报告恢复',
  purchase_restored_by_email: '通过邮箱恢复已购报告',
  report_access_restored: '恢复本机已购权益',
  share_card_generated: '生成分享卡片',
  share_completed: '完成分享或图片下载',
  share_card_error: '分享卡片生成失败',
  tarot_reading_viewed: '打开塔罗工具',
  tarot_card_drawn: '完成塔罗抽牌',
  tarot_timeline_viewed: '查看塔罗解读',
  tarot_bridge_clicked: '塔罗结果引导进入八字',
  tarot_love_reading_viewed: '打开关系塔罗工具',
  tarot_love_drawn: '完成关系塔罗抽牌',
  first_insight_engaged: '首条解读可见四秒',
  insight_evidence_opened: '展开首条解读依据',
  insight_resonance_selected: '反馈解读与经历的联系',
  reading_action_selected: '选择解读后的行动方向',
  activation_completed: '达到价值激活候选标准',
  activation_nudge_clicked: '点击首条解读助推',
});

export function analyticsLabelZh(event) {
  return Object.hasOwn(ANALYTICS_LABELS_ZH, event) ? ANALYTICS_LABELS_ZH[event] : undefined;
}
